
import React, { useEffect, useRef, useState } from 'react';
import { CustomerContactDetailsModel } from '../models/superbit-api-models';
import { tr } from 'date-fns/locale';

type Props = {
    contact: CustomerContactDetailsModel;
    index: number;
    config: any;
};
const ClientContact =(props: Props)=> {
    const [contactDetails, setContactDetails] = useState<CustomerContactDetailsModel>(new CustomerContactDetailsModel());
    const [isPrimary, setIsPrimary] = useState<boolean>(false);
    const [contactErrors, setContactErrors] = useState({
        phone: false,
        email: false,
        title: false
    });
    const [fieldRequired, setFieldRequired] = useState<string>('*שדה חובה');
    const [phoneChanged, setPhoneChanged] = useState<boolean>(false);
    const [dataState, setDataState] = useState<boolean>(false);


    const onParamChange = async (name: string, value: string) => {
        const contact = contactDetails;
        const errors = contactErrors;
        switch (name) {
            case 'title':
                errors.title = false;
                contact.title = value;
                setContactDetails(contact);  
                break;
            case 'emailAddress':
                errors.email = false;
                contact.emailAddress = value;
                setContactDetails(contact);
                if (value !== '') {
                    const emailIsValid = validateEmail(value);
                    if (!emailIsValid) {
                        errors.email = true;
                    } else {
                        errors.email = false;
                    }
                }
                setContactErrors(errors);
                break;
            case 'number':
                errors.phone = false;
                let number = value.replace(/\D/g, '');
                contact.number = number.trim();
                setContactDetails(contact);
                const phoneIsValid = await checkPhone(value);
                if (!phoneIsValid) {
                    errors.phone = true;
                } else {
                    errors.phone = false;
                }
                setContactErrors(errors);
                break;

            case 'comment':
                contact.comment = value;
                setContactDetails(contact);
                break;

            
            default:
                break;
        }
        onChange()
    }

    const onPhoneBlur = async() =>{
        setPhoneChanged(true);
        console.log('onPhoneBlur');
        const contact = contactDetails;
        const errors = contactErrors;
        const phoneIsValid = await checkPhone(contact.number as string);
        if (!phoneIsValid) {
            errors.phone = true;
        } else {
            errors.phone = false;
        }
        setContactErrors(errors);
        setPhoneChanged(false);
        checkTitle();
        // setContactDetails(contact);
    }

    const onPhoneFocus = () => {
        const errors = contactErrors;
        errors.phone = false;
        setContactErrors(errors);
        setDataState(!dataState);
    }

    const onTitleFocus = () => {
        const errors = contactErrors;
        errors.title = false;
        setContactErrors(errors);
        setDataState(!dataState);
    }

    const onEmailFocus =() =>{
        const errors = contactErrors;
        errors.email = false;
        setContactErrors(errors);
        setDataState(!dataState);
    }
    const onEmailBlur =() =>{
        const errors = contactErrors;
        errors.email = false;
        if (contactDetails.emailAddress && contactDetails.emailAddress !== '') {
            const emailIsValid = validateEmail(contactDetails.emailAddress);
            if (!emailIsValid) {
                errors.email = true;
            } else {
                errors.email = false;
            }
        }
        setContactErrors(errors);
        checkTitle();
    }

    const checkTitle = () => {
        const contact = contactDetails;
        const errors = contactErrors;
        if (!contact.title || contact.title==''){
            errors.title = true;
        }
        setContactErrors(errors);
        setDataState(!dataState);
        onChange();
    }
    
    const toggleIsPrimary = () => {
        const contact = contactDetails;
        const curStatus = contact.isPrimary;
        contact.isPrimary = !contact.isPrimary;
        setIsPrimary(!curStatus)
        setContactDetails(contact);
        console.log('toggleIsPrimary');
        onChange()
    }

    const onChange = () => {
        console.log('contactDetails', contactDetails)
        if(props.config.onChange) {
            if (contactErrors.title || contactErrors.phone || contactErrors.email) {
                contactDetails.hasError = true;
            } else {
                contactDetails.hasError = false;
            }
            
            props.config.onChange(contactDetails);
        }
    }

    const onDelete = () => {
        if (props.config.onDelete) {
            props.config.onDelete(contactDetails);
        }
    }

    // validations start
    
    const validateIsraelPhoneNumber = (phoneNumber: string): boolean => {
        if(phoneNumber.length === 9 && (phoneNumber.startsWith('05') || phoneNumber.startsWith('07') || phoneNumber.startsWith('01'))){
            return false;
        }
        // Regular expression for Israel phone numbers
        const israelPhoneNumberRegex = /^(0\d{1,2})-?(\d{3})-?(\d{4})$/;
        // Remove any non-digit characters from the phone number
        const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
        // Check if the cleaned phone number matches the Israel phone number regex
        return israelPhoneNumberRegex.test(cleanedPhoneNumber);
    }
    
    const checkPhone = async(number: string, type: string = 'mobile') => {
        let isValid = true;
        let phoneNumber = number ?  number.replace(/\D/g, '') : '';
        if(!phoneNumber || phoneNumber == '') {
            isValid = false;
        }
        if (phoneNumber && phoneNumber.startsWith('05')) {
            type = 'mobile';
        } else {
            type = 'phone';
        }
        switch (type) {
            case 'mobile':
                if (!phoneNumber || phoneNumber == '' || phoneNumber.length < 10 || !validateIsraelPhoneNumber(phoneNumber)) {
                    isValid = false;
                }
                break;
            case 'phone':
                
                if (phoneNumber && phoneNumber != '' && ((phoneNumber.length < 9) || !validateIsraelPhoneNumber(phoneNumber))) {
                    isValid = false;
                }
                break;
        
            default:
                break;
        }
        return isValid
    }

    
    const validateEmail= (email: string): boolean => {
        // Regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    
    
    const checkContact = async () => {
        const contact = contactDetails;
        const errors = contactErrors;
        console.log('checkContact-contact.number', contact.number)
        const phoneIsValid = props.index == 0 ? await checkPhone(contact.number as string) : true;
        console.log('checkContact-phoneIsValid', props.index,phoneIsValid)
        if (!phoneIsValid) {
            errors.phone = true;
        } else {
            errors.phone = false;
        }
        if (contact.title == '') {
            errors.title = true;
        }
        checkTitle();
        setPhoneChanged(false);
    }
    // validations end

    const emptyFunc = () => {}

    
    useEffect(()=>{
        setContactDetails(props.contact);
        if(props.contact.isPrimary) {
            setIsPrimary(props.contact.isPrimary)
        }
    }, [props.contact])

    useEffect(()=>{
        if (props.contact.hasError) {
            checkContact();
            console.log('hasError changed from outside');
        }
    }, [props.contact.hasError])
    
    // useEffect(()=>{
    //     console.log('checkContact', props.config.check);
    //     if(props.config.check) {
    //     }
    // },[props.config.check])

    return (
        <div className="parameter-row">
            <div className="parameter-item checkbox">
                <input type="checkbox" className="checkbox-input" id="checked01" name="client_type01" value="1" checked={isPrimary} onChange={emptyFunc} />
                <label className="pointer" onClick={toggleIsPrimary}></label>
            </div>
            <div className={`parameter-item ${contactErrors.title ? 'error' : ''}`}>
                <div className="field">
                    <div className="value">
                        <input type="text"  value={contactDetails.title} onChange={(e:any)=>onParamChange('title', e.target.value)} onBlur={checkTitle} onFocus={onTitleFocus} />
                    </div>
                    <div className='error-message'>
                        *שדה חובה
                    </div>
                </div>
            </div>
            <div className={`parameter-item ${contactErrors.email ? 'error' : ''}`}>
                <div className="field">
                    <div className="value">
                        <input type="text" value={contactDetails.emailAddress} onChange={(e:any)=>onParamChange('emailAddress', e.target.value)} onBlur={onEmailBlur} onFocus={onEmailFocus} />
                    </div>
                    <div className='error-message'>
                        {contactDetails.emailAddress == '' ? (<>
                            {fieldRequired}
                        </>):(<>
                        *כתובת וא"ל לא תקינה
                        </>)}
                    </div>
                </div>
            </div>
            <div className={`parameter-item ${contactErrors.phone ? 'error' : ''}`}>
                <div className="field">
                    <div className="value">
                        <input type="text" value={contactDetails.number} onChange={(e:any)=>onParamChange('number', e.target.value)} onBlur={()=>onPhoneBlur()} onFocus={onPhoneFocus} />
                    </div>
                    <div className='error-message'>
                        {!contactDetails.number || contactDetails.number == '' ? (<>
                            {fieldRequired}
                        </>):(<>
                            *מס'טלפון לא תקין
                        </>)}
                    </div>
                </div>
            </div>
            <div className="parameter-item">
                <div className="field">
                    <div className="value">
                        <input type="text"  value={contactDetails.comment} onChange={(e:any)=>onParamChange('comment', e.target.value)}/>
                    </div>
                </div>
            </div>
            <div className="parameter-item action">
                <div className={`icon trash-brown pointer ${props.config && props.config.canBeDeleted ? '' : 'hide'}`} onClick={onDelete}></div>
            </div>
        </div>

    )
}
export default ClientContact;